import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import AvatarEditor from '../components/AvatarEditor';
import axios from 'axios';
import { AlertIcon as AlertTriangle, ChevronLeftIcon as ChevronLeft } from '../components/Icons';

const EditAvatar = () => {
    const { user, API_URL } = useContext(AuthContext);
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleSave = async (url) => {
        setIsSaving(true);
        try {
            const config = { headers: { Authorization: `Bearer ${user.token}` } };
            await axios.put(`${API_URL}/users/profile`, { avatarUrl: url }, config);
            navigate('/');
        } catch (err) {
            setError('Fehler beim Speichern des Avatars.');
            setIsSaving(false);
        }
    };

    return (
        <div className="min-h-screen bg-surface">
            <div className="flex flex-col items-center min-h-screen pt-24 pb-16 px-4 md:px-6">
                <div className="w-full max-w-[1000px]">
                    <button
                        onClick={() => navigate('/')}
                        className="mb-6 flex items-center gap-2 text-surface-onVariant hover:text-primary transition-colors font-medium"
                    >
                        <ChevronLeft size={20} /> Zurück zum Dashboard
                    </button>

                    <h1 className="text-3xl font-bold text-surface-on mb-2 text-center">Avatar bearbeiten</h1>
                    <p className="text-surface-onVariant text-center mb-8">Erstelle deinen persönlichen Pfadfinder-Avatar.</p>

                    {error && (
                        <div className="mb-6 bg-error-container text-error-onContainer p-4 rounded-xl shadow-sm flex items-center gap-3">
                            <AlertTriangle size={24} />
                            <p>{error}</p>
                        </div>
                    )}

                    <div className="md3-card-elevated p-0 overflow-hidden mb-8 w-full">
                        <AvatarEditor onSave={handleSave} isSaving={isSaving} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditAvatar;
